import { type ComponentProps } from 'react'
import { twMerge } from 'tailwind-merge'
import { SYMBOL, SYMBOL_VIEWBOX } from './paths'

type HighlightLogoIconProps = Omit<ComponentProps<'svg'>, 'children' | 'dangerouslySetInnerHTML'>

/** The symbol, at the frame height its `HighlightLogo` sets. */
export function HighlightLogoIcon({ className, ...props }: HighlightLogoIconProps) {
  return (
    <svg
      viewBox={SYMBOL_VIEWBOX}
      aria-hidden
      fill="currentColor"
      className={twMerge('h-[var(--logo-h)] w-auto shrink-0', className)}
      // Trusted: paths exported from the Highlight 2.0 Brand file and checked in.
      dangerouslySetInnerHTML={{ __html: SYMBOL }}
      {...props}
    />
  )
}
